import './MainPage.scss'

import { mediaQueries } from '@tallink/components-lib/src/constants/media'
import { useQuery } from '@tallink/more-react-hooks'
import qs from 'query-string'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useEffectOnce, useMedia } from 'react-use'

import { initMainPage } from '../actions/actions'
import Booking from '../components/booking/Booking'
import Loader from '../components/common/Loader'
import Layout from '../components/layout/Layout'
import MainContent from '../components/layout/MainContent'
import UnsuccessfulPaymentCallout from '../components/Payment/UnsuccessfulPaymentCallout'
import SerialTicketHero from '../components/SerialTicketHero/SerialTicketHero'
import Sso from '../components/Sso/Sso'
import StickyFooter from '../components/StickyFooter/StickyFooter'
import Summary from '../components/Summary/Summary'
import { hasSelectedTickets, hasSerialTickets } from '../selectors/selectors'

export default function MainPage() {
  const { t } = useTranslation()
  const smUp = useMedia(mediaQueries.smUp)
  const dispatch = useDispatch()
  const serialTicketsLoaded = useSelector(hasSerialTickets)
  const serialTicketsSelected = useSelector(hasSelectedTickets)
  const history = useHistory()
  const [paymentRejected] = useState(useQuery('backendError') === 'paymentRejected')
  const [paymentCancelled] = useState(useQuery('backendError') === 'paymentCancelled')

  useEffectOnce(() => {
    history.replace(qs.exclude(history.location.search, ['backendError']))
  })

  useEffect(() => {
    if (!serialTicketsLoaded) {
      dispatch(initMainPage())
    }
  }, [dispatch, serialTicketsLoaded])

  return (
    <Layout pageTitle={t('mainPage.title')}>
      {!serialTicketsLoaded && <Loader />}
      {paymentRejected || paymentCancelled ? (
        <section className="main-page callout-placeholder">
          <UnsuccessfulPaymentCallout
            title={t(paymentCancelled ? 'payment.cancelled.title' : 'payment.unsuccessful.title')}
          />
        </section>
      ) : (
        <SerialTicketHero />
      )}
      {!smUp && <Sso />}
      <section className="main-page">
        <MainContent aside={smUp && <Summary />} main={<Booking />} />
      </section>
      {serialTicketsSelected && <StickyFooter />}
    </Layout>
  )
}
